import { useMemo, useState, useEffect } from "react";
import TableAulasGrupo from "../../Components/TableAulasGrupo";
import { decodeJWT, formatDateTime } from "../../Components/jwtUtils";
import Api from "../../Auth/Api";
import { Modal, Badge, Offcanvas } from "react-bootstrap";
import TableInfoAulaGrupo from "../../Components/TableInfoAulaGrupo";
import Select from 'react-select';
import DropdownMenu from "../../Components/DropdownMenu";
import { customStyles } from '../../utils/selectStyles';

function RelatorioGrupo() {
	const token = JSON.parse(localStorage.getItem("user_token"));
	const tokenDecodifado = decodeJWT(token);
	const nivel = tokenDecodifado.nivel;

	const [dataAulas, setDataAulas] = useState([]);
	const [selectedFilter, setSelectedFilter] = useState(nivel === 'Gestor' ? tokenDecodifado.idUsuario : null);
	const [selectedUnidade, setSelectedUnidade] = useState(null);
	const [dataInicio, setDataInicio] = useState('');
	const [dataFim, setDataFim] = useState('');
	const [listFilters, setListFilters] = useState([]);
	const [showModalList, setShowModalList] = useState({ show: false, content: null });
	const [dataInfoAula, setDataInfoAula] = useState([]);
	const [globalFilter, setGlobalFilter] = useState('');
	const [pageSize, setPageSize] = useState(20);
	const [showDrawerFiltros, setShowDrawerFiltros] = useState(false);

	useEffect(() => {
		async function fetchData() {
			try {
				const params = {};
				if (selectedUnidade) {
					params.unidade = selectedUnidade.value;
				}
				if (dataInicio) {
					params.dataInicio = dataInicio;
				}
				if (dataFim) {
					params.dataFim = dataFim;
				}
				
				const response = await Api.get(`api/listar-aulas-grupo/${selectedFilter}`, {
					headers: {
						Authorization: `Bearer ${token}`
					},
					params: params
				});
				setDataAulas(response.data.data);
			} catch (error) {
				console.error("Erro ao carregar aulas em grupo:", error.response.data.message);
			}
		}
		fetchData();
	}, [token, selectedFilter, selectedUnidade, dataInicio, dataFim]);

	// Fazer lista do filtro
	useEffect(() => {
		async function fetchData() {
			try {
				const response = await Api.get(`api/listar-aulas-grupo/null`, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				});
				setListFilters(response.data.data);
			} catch (error) {
				console.error("Erro ao carregar lista de filtros:", error.response.data.message);
			}
		}
		fetchData();
	}, [token]);

	const columns = useMemo(
		() => [
			{
				Header: "ID",
				accessor: "id"
			},
			{
				Header: () => null,
				id: 'nomeAula',
				accessor: row => row.nomeAula,
				Cell: ({ cell: { value }, row: { original } }) => (
					<div className="d-flex flex-column">
						<div className="fw-semibold">{value}</div>
						<div className="small">{original.nomeModulo}</div>
					</div>
				)
			},
			{
				Header: () => null,
				id: 'nomeGestor',
				accessor: row => row.nomeGestor,
				Cell: ({ cell: { value }, row: { original } }) => (
					<div> <i className="bi bi-person"></i> {value}</div>
				)
			},
			{
				Header: () => null,
				id: 'data',
				accessor: row => row.data,
				Cell: ({ cell: { value }, row: { original } }) => (
					<div> <i className="bi bi-calendar"></i> {formatDateTime(value)}</div>
				)
			},
			{
				Header: () => null,
				id: 'acoes',
				accessor: row => row.id,
				Cell: ({ cell: { value }, row: { original } }) => (
					<div className="d-flex">
						<DropdownMenu
							items={[
								{
									icon: 'eye',
									label: 'Visualizar',
									onClick: () => setShowModalList({ show: true, content: original })
								}
							]}
							align="end"
						/>
					</div>
				)
			},
		],
		[]
	);

	const filterSelect = useMemo(() => {

		const uniqueGestors = new Map();
		listFilters.forEach(aula => {
			if (!uniqueGestors.has(aula.idGestor)) {
				uniqueGestors.set(aula.idGestor, { value: aula.idGestor, label: aula.nomeGestor });
			}
		});
		return Array.from(uniqueGestors.values());

	}, [listFilters]);

	const unidades = useMemo(() => {
		const allUnidades = listFilters.map(item => item.unidade).filter(Boolean);
        return [...new Set(allUnidades)].map(unidade => ({ value: unidade, label: unidade }));
    }, [listFilters]);

    useEffect(() => {
		async function fetchData() {
			try {
				const response = await Api.get(`api/listar-info-aula-grupo/${showModalList.content.id}`, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				});
				setDataInfoAula(response.data);
			} catch (error) {
				console.error("Erro ao carregar informações da aula:", error.response.data.message);
			}
		}

		showModalList.content && fetchData();
	}, [token, showModalList.content]);

	return (
		<>
			<div className="fade-in w-100 mt-3" style={{ marginBottom: '100px' }}>
				{/* Header Moderno */}
				<div className="rounded-3 mb-4">
					<div className="mb-3">
						<h1 className="text-primary fs-2 fw-bold mb-2">Lista de Aulas em Grupo</h1>
						<p className="text-muted mb-0">Consulte as aulas realizadas em grupo, filtre e visualize</p>
					</div>
				</div>

				{/* Barra de Filtros Compacta */}
				<div className="card border-0 shadow-sm mb-3">
					<div className="card-body p-3">
						<div className="row g-2 align-items-end">
							<div className="col-md-4">
								<label className="form-label text-primary fw-medium small mb-1">Buscar</label>
								<div className="inner-addon right-addon">
									<i className="d-flex bi bi-search" />
									<input
										type="search"
										placeholder="Pesquise pelo nome..."
										className="form-control py-2"
										value={globalFilter || ""}
										onChange={(e) => setGlobalFilter(e.target.value)}
									/>
								</div>
							</div>
							<div className="col-md-4">
								<label className="form-label text-primary fw-medium small mb-1">Gestor</label>
								<Select
									options={filterSelect.map((value) => ({
										value: value.value,
										label: value.label,
									}))}
									styles={customStyles}
									placeholder="Selecione o gestor"
									value={selectedFilter ? filterSelect.find(f => f.value === selectedFilter) : null}
									onChange={(selectedOption) => {
										setSelectedFilter(selectedOption ? selectedOption.value : null);
									}}
									isClearable
									menuPortalTarget={document.body}
									menuPosition="fixed"
								/>
							</div>
							<div className="col-md-4">
								<button
									className="btn btn-outline-primary w-100 py-2"
									onClick={() => setShowDrawerFiltros(true)}
								>
									<i className="bi bi-funnel me-1"></i>
									Mais filtros
								</button>
							</div>
						</div>
					</div>
				</div>

				{/* Chips de Filtros Ativos */}
				{(selectedFilter || selectedUnidade || dataInicio || dataFim) && (
					<div className="mb-3 d-flex flex-wrap gap-2 align-items-center">
						{selectedFilter && (
							<Badge bg="primary" className="d-flex align-items-center gap-1 px-3 py-2" style={{ fontSize: '0.875rem' }}>
								Gestor: {filterSelect.find(f => f.value === selectedFilter)?.label}
								<i 
									className="bi bi-x cursor-pointer" 
									onClick={() => setSelectedFilter(null)}
									style={{ cursor: 'pointer' }}
								></i>
							</Badge>
						)}
						{selectedUnidade && (
							<Badge bg="info" className="d-flex align-items-center gap-1 px-3 py-2" style={{ fontSize: '0.875rem' }}>
								Unidade: {selectedUnidade.label}
								<i 
									className="bi bi-x cursor-pointer" 
									onClick={() => setSelectedUnidade(null)}
									style={{ cursor: 'pointer' }}
								></i>
							</Badge>
						)}
						{(dataInicio || dataFim) && (
							<Badge bg="secondary" className="d-flex align-items-center gap-1 px-3 py-2" style={{ fontSize: '0.875rem' }}>
								Período: {dataInicio ? new Date(dataInicio).toLocaleDateString('pt-BR') : '...'} até {dataFim ? new Date(dataFim).toLocaleDateString('pt-BR') : '...'}
								<i 
									className="bi bi-x cursor-pointer" 
									onClick={() => {
										setDataInicio('');
										setDataFim('');
									}}
									style={{ cursor: 'pointer' }}
								></i>
							</Badge>
						)}
					</div>
				)}

				<TableAulasGrupo 
					titulo="Relatórios em grupo" 
					columns={columns} 
					data={dataAulas}
					search={false}
					globalFilter={globalFilter}
					pageSize={pageSize}
					setPageSize={setPageSize}
				/>
			</div>

			{showModalList.content &&
				<Modal size="lg" show={showModalList.show} onHide={() => setShowModalList({ show: false, content: null })}>
					<Modal.Header closeButton>
						<span className="fw-semibold fs-5 text-primary">Relátorio de {showModalList.content.nomeGestor}</span>
					</Modal.Header>
					<Modal.Body className="p-0">
						<TableInfoAulaGrupo data={dataInfoAula} />
					</Modal.Body>
					<Modal.Footer>
						<div className="d-flex justify-content-center mb-1 gap-2">
							<button type="button" className="btn btn-outline-primary text-primary px-5 py-2" onClick={() => setShowModalList({ show: false, content: null })}>Voltar</button>
						</div>
					</Modal.Footer>
				</Modal>
			}

			{/* Drawer de Filtros Avançados */}
			<Offcanvas show={showDrawerFiltros} onHide={() => setShowDrawerFiltros(false)} placement="end" style={{ width: '400px' }}>
				<Offcanvas.Header closeButton>
					<Offcanvas.Title className="fw-semibold fs-5 text-primary">Filtros Avançados</Offcanvas.Title>
				</Offcanvas.Header>
				<Offcanvas.Body className="bg-gray-100 d-flex flex-column">
					<div className="mb-3">
						<label className="form-label text-primary fw-medium mb-2">Unidade</label>
						<Select
							options={unidades}
							styles={customStyles}
							placeholder="Selecione a unidade"
							value={selectedUnidade}
							onChange={(selectedOption) => {
								setSelectedUnidade(selectedOption);
							}}
							isClearable
							menuPortalTarget={document.body}
							menuPosition="fixed"
							menuShouldScrollIntoView={false}
						/>
					</div>
					<div className="mb-3">
						<label className="form-label text-primary fw-medium mb-2">Período</label>
						<div className="row g-2">
							<div className="col-12">
								<label className="form-label small text-muted mb-1">Data Início</label>
								<input
									type="date"
									className="form-control py-2"
									value={dataInicio}
									onChange={(e) => setDataInicio(e.target.value)}
								/>
							</div>
							<div className="col-12">
								<label className="form-label small text-muted mb-1">Data Fim</label>
								<input
									type="date"
									className="form-control py-2"
									value={dataFim}
									onChange={(e) => setDataFim(e.target.value)}
								/>
							</div>
						</div>
					</div>
					<div className="mb-3">
						<label className="form-label text-primary fw-medium mb-2">Registros por página</label>
						<select className="form-select py-2" value={pageSize} onChange={e => setPageSize(Number(e.target.value))}>
							{[20, 50, 100, 500, 1000].map(size => (
								<option key={size} value={size}>
									{size}
								</option>
							))}
						</select>
					</div>
					<div className="mt-auto pt-3 border-top">
						<div className="d-flex gap-2">
							<button
								type="button"
								className="btn btn-outline-secondary flex-fill"
								onClick={() => {
									setSelectedUnidade(null);
									setDataInicio('');
									setDataFim('');
									setPageSize(20);
								}}
							>
								Limpar filtros
							</button>
							<button
								type="button"
								className="btn btn-primary flex-fill"
								onClick={() => setShowDrawerFiltros(false)}
							>
								Aplicar filtros
							</button>
						</div>
					</div>
				</Offcanvas.Body>
			</Offcanvas>
		</>
	);
}

export default RelatorioGrupo;